// extracted by mini-css-extract-plugin
export default {"numberSelect":"dcc_numberSelect-numberSelect","labelText":"dcc_numberSelect-labelText","select":"dcc_numberSelect-select"};